// extracted by mini-css-extract-plugin
export default {"navbar":"NavBar_navbar__tYBQP","navbar_links_container":"NavBar_navbar_links_container__KNmMm","navbar_link":"NavBar_navbar_link__hrtfU"};